// Story 1.22 — rendered when GET /api/v1/creators/me returns
// 403 CREATOR_PROFILE_FORBIDDEN with reason="not_approved".
//
// Routes the user to the application form (Story 1.21's surface).

import { Card, CardContent, CardHeader, CardTitle } from "@greenhold/components";
import { Link } from "react-router-dom";

export function NotApprovedCard() {
  return (
    <Card className="max-w-xl mx-auto">
      <CardHeader>
        <CardTitle>You're not a Greenhold creator yet</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p>
          Only approved creators can edit a creator profile. Apply once and our
          team reviews within 48 hours.
        </p>
        <Link
          to="/account/become-creator"
          className="inline-block underline decoration-dotted"
        >
          Apply to become a Greenhold creator →
        </Link>
      </CardContent>
    </Card>
  );
}
